import { darken, lighten, rgba } from "polished";
import styled from "styled-components";
import ButtonPrimary from "../../components/ButtonPrimary";
import GalleryImages from "../../components/GalleryImages";
import { device } from "../../styles/device";
import ButtonSecondary from "../../components/ButtonSecondary";

export const Container = styled.div`
  width: 100%;

  span.new-product {
    background: #00bfdf;
    min-width: 80px;
    height: 30px;
    width: 20%;
    justify-content: center;
    align-items: center;
    display: flex;
    font-size: 1.4rem;
    color: ${props => props.theme.colors.bodyDark};
    border-radius: 2px;
    margin-left: 10px;
    padding: 0 5px;
  }
`;

export const ContainerProduct = styled.div`
  /* padding: 24px 16px;

  @media ${device.laptop} {
    padding: 24px 32px;
  } */

  .route-detail{
    max-width: 1440px;
    margin: 0 auto;
    margin-bottom: 20px;
    font-size: 14px;

    p{
      color: ${props => props.theme.colors.black};
    }
  }
  .detail-container {
    max-width: 1440px;
    margin: 0 auto;
    background: ${props => props.theme.colors.white};
    border: 1px solid ${props => props.theme.colors.neutralBorder};
    border-radius: 24px;
    padding: 24px;
    display: grid;
    grid-template-columns: 1fr;
    gap: 32px;

    @media ${device.laptop} {
      grid-template-columns: 1fr 1fr;
      padding: 40px;
      align-items: start;
    }
  }
`;

export const ContainerSpecialPricesList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const BasketHeader = styled.div`
  display: flex;
  width: 100%;
  height: 75px;
  align-items: center;
  background: #f5f5f5;
  border-bottom: 1px solid #ecf0f1;
  margin-top: 86px;
  justify-content: center;

  @media (max-width: 900px) {
    margin-top: 130px;
  }

  @media (max-width: 420px) {
    height: 80px;
  }

  > div {
    max-width: 1440px;
    width: 100%;
    padding: 0 20px;
    display: flex;
    justify-content: space-between;

    button {
      font-size: 1.4rem;
    }

    @media (max-width: 420px) {
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding: 0;

      button {
        font-size: 1.4rem;
        padding: 10px;
        svg {
          font-size: 1.8rem;
        }
      }
    }

    > span {
      font-weight: 500;
      font-size: 2.2rem;
      color: ${props => props.theme.colors.primary};
      text-transform: uppercase;

      @media (max-width: 420px) {
        flex-direction: column;
      }
    }
  }
`;

export const LoaderContainer = styled.div`
  display: flex;
  min-height: 100vh;
  margin-top: 86px;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;

export const ProductHeader = styled.div`

`;

export const NotFoundContainer = styled.div`
  display: flex;
  min-height: 60vh;
  margin-top: 86px;
  padding: 24px 16px;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 12px;
  text-align: center;

  h2 {
    font-size: var(--title-3, 2.4rem);
    color: ${props => props.theme.colors.ink};
  }

  p {
    color: ${props => props.theme.colors.neutralText};
    max-width: 420px;
  }
`;

export const Warning = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5px;
  border: 1px solid ${props => props.theme.colors.warning};
  border-radius: 2px;
  margin-bottom: 10px;
  align-self: flex-start;
  text-align: center;
  margin-top: 16px;

  span {
    font-weight: 500;
    color: ${props => props.theme.colors.warning};
    font-size: 1.4rem;
    line-height: 2rem;
  }
`;

export const ImageContainer = styled.div`
  align-self: center;
  display: flex;
  position: relative;
  justify-content: center;
  align-items: center;
  height: 202px;
  width: 328px;

  @media ${device.laptop} {
    height: 497px;
    width: 690px;
    align-self: flex-start;
    display: none;
  }

  border: 1px solid ${props => props.theme.colors.grayLight};
  img {
     object-fit: contain;
     max-width: 328px;
     max-height: 202px;

     @media ${device.laptop} {
        max-height: 497px;
        max-width: 690px;
    }
  }

`;

export const ProductShop = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  min-width: 0;

  .price{
    display: flex;
    flex-direction: column;
  }
`;

export const ProductDescription = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;

  div.product-attributes {
    margin: 10px 0;
    ul {
      list-style: none;
      li {
        text-transform: uppercase;
        font-size: 1.4rem;
        color: ${props => lighten(0.05, props.theme.colors.secondary)};
        font-weight: 500;
      }
    }
  }
`;

export const GalleryImagesStyled = styled(GalleryImages)`
  margin-top: 16px;
  display: initial;
  @media ${device.laptop} {
    display: none;
  }
`;

export const ContainerPromo = styled.div`
    background-color: #00bf63;
    border-radius: 999px;
    padding: 6px 14px;
    position: absolute;
    top: 12px;
    left: 12px;
    z-index: 2;
    display: flex;
    justify-content: center;
    align-items: center;

    span{
        font-size: 14px;
        font-weight: 700;
        color: ${props => props.theme.colors.white};
    }
`;

export const ContainerGalleryImages = styled.div`
  width: 100%;
  display: none;
  @media ${device.laptop} {
    display: block;
  }
`;

export const ContainerName = styled.div`
  h1 {
    font-family: 'Sora', system-ui, sans-serif;
    font-size: 24px;
    font-weight: 700;
    line-height: 1.25;
    color: ${props => props.theme.colors.ink};
    margin-bottom: 12px;

    @media ${device.laptop} {
      font-size: 30px;
    }
  }
`;

export const ContainerInteract = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 8px;
  width: 100%;
`;

export const ContainerSummary = styled.div`
  margin-top: 20px;
`;

export const ContainerInteractFirstColumn = styled.div`
   display: flex;
   flex-direction: column;
`;

export const ContainerManufacturer = styled.div`
  align-self: flex-start;
  background-color: ${props => props.theme.colors.primary50};
  border-radius: 8px;
  padding: 4px 8px;
  display: flex;
  justify-content: center;

  span {
    color: ${props => props.theme.colors.primaryDark};
    font-size: 14px;
    font-weight: 700;
  }
`;

export const ContainerRegistroANVISA = styled.div`
  align-self: flex-start;
  background-color: ${props => props.theme.colors.grayLight};
  border-radius: 8px;
  padding: 4px 8px;
  display: flex;
  justify-content: center;
  margin-top: 30px;

  span {
    color: ${props => props.theme.colors.primaryDark};
    font-size: 12px;
    font-weight: 600;
  }
`;

export const ContainerInteractSecondColumn = styled.div`
  display: inline-flex;
  gap: 16px;
`;

export const ProductPriceContainer = styled.div`
  display: flex;
  width: 100%;
`;

export const ProductPriceFirstColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const ContainerAdvantageCard = styled.div`
  margin-left: 28px;

  img{
    height: 35px;
    width: 52px;
  }
`;

export const ContainerInfoAdvantageCard = styled.div`
  display: inline-flex;
  background-color: ${props => props.theme.colors.primary30};
  border-radius: 8px;
  margin-top: 33px;
  justify-content: flex-start;
  margin-bottom: 32px;
`;

export const ContainerInfoAdvangateCardFirstColumn = styled.div`
  display: inline-flex;
  padding: 16px 12px 12px 14px;

  img{
    align-self: center;
    width: 91px;
    height: 59px;
    margin-right: 9px;
  }
`;

export const ContainerInfoEconomyWithAdvantageCard = styled.div`
border-right: 1px solid ${props => props.theme.colors.gray};
padding-right: 16px;
  span{
    font-size: 13px;
  }
`;

export const TextEconomyWithAdvantageCard = styled.span`
  font-size: 25px !important;
  color: ${props => props.theme.colors.error};
`;

export const ContainerInfoAdvantageCardSecondColumn = styled.div`
  display: inline;
  margin: auto 0px;

  span {
    font-size: 14px;
  }
`

export const TextOldValue = styled.span`
  text-decoration: line-through;
  font-size: 14px;
  color: ${props => props.theme.colors.neutralText};
`;

export const ContainerNewValue = styled.div`
  display: inline-flex;
  align-items: baseline;

  > span {
    font-size: 18px;
    font-weight: 700;
    color: ${props => props.theme.colors.ink};
    margin-right: 4px;
  }
`;

export const TextNewValue = styled.span`
  font-family: 'Sora', system-ui, sans-serif;
  font-size: 40px !important;
  font-weight: 800;
  line-height: 1;
  color: ${props => props.theme.colors.ink};
`;

// Selo do Pix ao lado do preço grande (P-113)
export const PixHint = styled.span`
  align-self: center;
  margin-left: 10px;
`;

export const InstallmentText = styled.span`
  font-size: 12px;
  color: ${props => props.theme.colors.neutralText};
  margin-top: 8px;
`;

export const InstallmentHint = styled.span`
  font-size: 11px;
  color: ${props => props.theme.colors.primary};
`;

export const ContainerRealPrice = styled.div`
`;

export const ContainerDiscountPrice = styled.div`
`;

export const ProductPriceSecondColumn = styled.div`
  display: inline-flex;
  margin-left: 42px;
`

export const ContainerWithoutStock = styled.div`
    margin-top: 24px;
    display: flex;
    flex-direction: column;
    align-items: stretch;

    span{
        color: ${props => props.theme.colors.primary};
        font-size: 20px;
        font-weight: 700;

    }
`;

export const ContainerButtonDisp = styled.div`
  margin-top: 24px;
  display: flex;
  align-items: center;
`;

export const ProductOffer = styled.div`
  display: flex;
  margin: 0 0 10px 0;

  span.offer-discount {
    background: ${props => props.theme.colors.discountFlag};
    width: 100%;
    max-width: 120px;
    height: 30px;
    justify-content: center;
    align-items: center;
    display: flex;
    font-size: 1.4rem;
    color: ${props => props.theme.colors.bodyDark};
    border-radius: 2px;
  }

  span.offer-economy {
    background: ${props => props.theme.colors.success};
    min-width: 148px;
    height: 30px;
    justify-content: center;
    align-items: center;
    display: flex;
    font-size: 1.4rem;
    color: ${props => props.theme.colors.bodyDark};
    border-radius: 2px;
    margin-left: 10px;
    padding: 0 5px;
  }
`;

export const Counter = styled.div`
  margin: 10px 0;
  height: 50px;
  display: flex;
  width: 100%;
  max-width: 325px;
  justify-content: space-between;
  border-top: 1px solid #dde1e7;
  border-bottom: 1px solid #dde1e7;
  box-shadow: 0px 2px 0 rgba(0, 0, 0, 0.15);

  @media (max-width: 600px) {
    max-width: 100%;
  }

  .counter-content {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    background: #fff;
    align-items: center;

    span.label {
      font-weight: 500;
      color: ${props => props.theme.colors.bodyLight};
      display: flex;
      align-self: center;
      display: flex;
      justify-content: flex-start;
      width: 90px;
      padding: 10px;
      font-size: 1.4rem;
      position: relative;

      span {
        top: 2px;
        right: 23px;
        height: 20px;
        display: flex;
        padding: 0 4px;
        z-index: 1;
        color: #ffffff;
        background: ${props => props.theme.colors.secondary};
        position: absolute;
        flex-wrap: wrap;
        font-size: 0.75rem;
        min-width: 20px;
        align-items: center;
        font-weight: 500;
        align-content: center;
        border-radius: 10px;
        flex-direction: row;
        justify-content: center;
        font-size: 1.2rem;
      }
    }

    .counter-content__input {
      border: none;
      height: 100%;
      background: #fff;
      font-size: 2.6rem;
      width: 40%;
      font-weight: 600;
      text-align: center;
      color: ${props => props.theme.colors.headingLight};
    }
  }

  .counter-button--increment {
    width: 35%;
    border: none;
    font-weight: 300;
    color: #909090;
    font-size: 3.4rem;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    border-left: 1px solid #dde1e7;
    border-right: 1px solid #dde1e7;

    :active {
      background: ${darken(0.05, "#fff")};
    }
  }

  .counter-button--decrement {
    width: 35%;
    border: none;
    border-left: 1px solid #dde1e7;
    border-right: 1px solid #dde1e7;
    font-weight: 300;
    color: #909090;
    font-size: 3.4rem;
    background: #fff;
    align-items: center;
    justify-content: center;

    :active {
      background: ${darken(0.05, "#fff")};
    }
  }
`;

export const ProductShopAction = styled.div`
  margin: 10px 0;
  button {
    width: 100%;
    max-width: 325px;
    background: ${props => props.theme.colors.primary};
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    font-size: 1.4rem;
    color: #ffffff;
    font-weight: 700;
    text-transform: uppercase;
    border-radius: 4px;
    box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.3);

    :active {
      background: ${props => darken(0.03, props.theme.colors.primary)};
    }

    @media (max-width: 600px) {
      max-width: 100%;
    }
  }
`;

export const ProductAlerts = styled.div`
  display: inline-flex;
`;

export const ProductAlertsDescription = styled.div`

`

export const ProductInfo = styled.div`
  width: 100%;
  max-width: 1440px;
  margin: 0 auto;
  padding: 10px;
  justify-content: center;
  display: flex;
`;

export const ProductContent = styled.div`
  width: 100%;
  max-width: 900px;
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;

  h1 {
    align-self: flex-start;
    font-weight: 500;
    font-size: 2.5rem;
    color: ${props => props.theme.colors.primary};
    padding: 20px 0;
    width: 100%;
    padding: 15px;
  }

  p {
    font-size: 1.6rem;
    color: ${props => props.theme.colors.bodyLight};
    line-height: 25px;
    width: 100%;
    padding: 5px 15px;
  }

  @media (max-width: 450px) {
    h1 {
      font-size: 2.2rem;
    }
  }
`;

export const ContainerProductIntroductionDesktop = styled.div`
    display: initial;
  @media ${device.laptop} {
    display: none;
  }
`;

export const ContainerProductIntroduction = styled.div`
  width: 100%;
  margin: 50px auto 120px auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 30px;

  .text-center {
    align-self: center;
  }

  div {
    display: flex;
    flex-direction: column;
    gap: 15px;
  }

  h2 {
      color: ${props => props.theme.colors.primary};
      font-size: 25px;
      font-weight: 700;
  }

  p {
    color: ${props => props.theme.colors.bodyLight};
    font-size: 16px;
    line-height: 1.55;
    margin: 0;
  }
`;

export const Subtitle = styled.h2`
  font-size: 20px;
    font-weight: 700;
    color: ${props => props.theme.colors.primary};
    margin-bottom: 12px;
`;

export const ContainerProductCharacteristics = styled.div`
  margin-top: 30px;
  display: flex;
  flex-direction: column;

  table {
    border-spacing: 0 4px;
    tr {
      background-color: #f0f4fc;
    }
    tr > td:first-child{
      font-weight: 700;
      color: ${props => props.theme.colors.black};
    }

    td {
      padding: 10px;
    }

  }
`;

export const ContainerCharacteristic = styled.div`
  margin-bottom: 30px;
  p{
    font-size: 16px;
    color: ${props => props.theme.colors.bodyLight};
  }
`;

export const InfoHeaderTitle = styled.div`
  width: 100%;
  height: 80px;
  background: #f5f5f5;
  margin-top: 50px;
  display: flex;
  align-items: center;

  h1 {
    padding-left: 15px;
    max-width: 1440px;
    margin: 0 auto;
    font-weight: 500;
    width: 100%;
    font-size: 2.5rem;
    color: ${props => props.theme.colors.primary};
    text-transform: uppercase;
  }

  @media (max-width: 600px) {
    margin-top: 15px;
    h1 {
      font-size: 2.2rem;
    }
  }

  @media (max-width: 450px) {
    h1 {
      font-size: 2.2rem;
    }
  }
`;

export const StyledButtonPrimary = styled(ButtonPrimary)`
  margin-top: 27px;
`;

export const StyledButtonSecondary = styled(ButtonSecondary)`
  margin-top: 27px;

  @media ${device.laptop} {
    margin-left: 16px;
  }
`;

export const StyledProductAlert = styled.div`
  margin-top: 49px;
`;

export const ContainerAddCart = styled.div`
  display: flex;
  flex-direction: column;

  @media ${device.laptop} {
    flex-direction: row;
  }
`;

export const ContainerDatails = styled.div`
    width: 100%;
    padding: 12px;
    position: absolute;
    bottom: 0px;
    left: 0px;
    border-radius: 0px 0px 8px 8px;
    background-color: red;
    display: flex;
    flex-direction: column;
    align-items: center;

    span{
        font-size: 11px;
        color: ${props => props.theme.colors.white};
        @media ${device.laptop} {
            font-size: 16px;
        }
        font-weight: 700;
    }
`;

export const FormGroup = styled.div`
  flex-direction: column;
  display: flex;
  gap: 8px;

  #registerNumber::placeholder{
    font-size: 14px;
  }
`;

export const Label = styled.label`
  font-size: 14px;
  font-size: 14px;
    color: ${props => (props.invalid ? props.theme.colors.warning : props.theme.colors.neutral900)};
`;

export const InputField = styled.input`
  width: 100%;
  height: 56px;
  background: #ffffff;
  border: 1px solid
    ${props => (props.invalid ? props.theme.colors.warning : "#ECECEC")};
  box-sizing: border-box;
  padding-left: 10px;
  margin-bottom: 20px;
  font-size: 16px;
  outline: none;
  transition: all 0.3s ease;
  -webkit-appearance: none;
  border-radius: 10px;

  :focus {
    border: 1px solid
      ${props =>
    props.invalid
      ? props.theme.colors.warning
      : props.theme.colors.primary};
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }

  :focus + label {
    color: ${props =>
    props.invalid ? props.theme.colors.warning : props.theme.colors.primary};
  }

  &:disabled {
    background-color: ${darken(.06, "#ffffff")};
    opacity: 0.8;
    cursor: not-allowed;
  }

  ::placeholder {
    color: ${props => props.theme.colors.bodyLight};
  }
`;

export const SubmitButton = styled.button`
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${props => props.theme.colors.bodyDark};
  background: ${props => props.theme.colors.primary};
  font-size: 1.6rem;
  border-radius: 40px;
  border: none;
  transition: 0.3s;
  cursor: pointer;
  border: 1px solid #cecece78;
  font-weight: 500;
  margin-top: 30px;

  &:hover {
    opacity: 0.9;
  }

  :disabled {
    opacity: 0.7;
  }

  @media (max-width: 600px) {
    max-width: 100%;
    margin-top: 0;
  }
`;

export const FieldErrorMessage = styled.div`
  color: ${props => props.theme.colors.warning};
  font-size: 14px;
  margin-top: 5px;
`;

export const Line = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  @media ${device.tablet}{
    flex-direction: row;
    justify-content: space-between;
  }
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow-y: auto;
  left: 0;
`;

/* ===================== Redesign da pagina de produto ===================== */

// Fabricante como texto simples (maiusculo, cinza) acima do H1
export const ManufacturerText = styled.span`
  display: block;
  color: ${props => props.theme.colors.neutralText};
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 1px;
  text-transform: uppercase;
  margin-bottom: 6px;
`;

// Badge verde "Novo" (mesma posicao do ContainerPromo)
export const BadgeNew = styled.div`
  background-color: ${props => props.theme.colors.success};
  border-radius: 0px 8px 0px 8px;
  padding: 8px 16px;
  position: absolute;
  top: 0px;
  left: 0px;
  display: flex;
  justify-content: center;
  align-items: center;

  span {
    font-size: 14px;
    font-weight: 700;
    color: ${props => props.theme.colors.white};
  }
`;

// Linha de principios ativos + atributos abaixo do H1
export const PrinciplesRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  margin-top: 12px;
`;

export const PrincipleBadge = styled.span`
  background-color: ${props => props.theme.colors.neutralBg};
  color: ${props => props.theme.colors.ink};
  font-size: 14px;
  padding: 2px 8px;
  border-radius: 6px;
`;

export const AttrText = styled.span`
  color: ${props => props.theme.colors.neutralText};
  font-size: 14px;
`;

export const RatingPlaceholder = styled.div`
  margin-top: 12px;
  color: ${props => props.theme.colors.neutralText};
  font-size: 14px;
`;

// Destaque do produto (resumo_descricao, texto simples; quebras de linha preservadas)
export const Highlights = styled.div`
  margin-top: 16px;
  white-space: pre-line;
  font-size: 14px;
  color: ${props => props.theme.colors.ink};
  line-height: 1.5;

  ul {
    padding-left: 20px;
    margin: 0;
    list-style: disc;
  }

  li {
    font-size: 14px;
    color: ${props => props.theme.colors.ink};
    line-height: 1.5;
    margin-bottom: 6px;
  }
`;

export const Divider = styled.hr`
  border: none;
  border-top: 1px solid ${props => props.theme.colors.neutralBorder};
  margin: 20px 0;
  width: 100%;
`;

// Bloco de preco (sem seletor de quantidade, movido para a linha de acao)
export const PriceBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  /* border-top: 1px solid ${props => props.theme.colors.neutralBorder};
  border-bottom: 1px solid ${props => props.theme.colors.neutralBorder}; */
  padding: 0;
  margin: 8px 0;
`;

// Linha de acao: seletor + adicionar ao carrinho + favorito
export const ActionRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  margin-top: 16px;
`;

// Botao proprio de adicionar ao carrinho (pill, cor primaria)
export const AddToCartButton = styled.button`
  flex: 1;
  min-width: 180px;
  height: 48px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 0 20px;
  border: none;
  border-radius: 999px;
  background: ${props => props.theme.colors.primary};
  color: ${props => props.theme.colors.white};
  font-size: 15px;
  font-weight: 700;
  cursor: pointer;
  transition: background 0.2s;

  svg {
    width: 20px;
    height: 20px;
  }

  &:hover {
    background: ${props => darken(0.06, props.theme.colors.primary)};
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const FavoriteButton = styled.button`
  width: 48px;
  height: 48px;
  flex-shrink: 0;
  border: 1px solid
    ${props => (props.active ? props.theme.colors.error : props.theme.colors.neutralBorder)};
  border-radius: 50%;
  background: ${props => (props.active ? rgba(props.theme.colors.error, 0.05) : props.theme.colors.white)};
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: 0.2s;

  svg {
    color: ${props => (props.active ? props.theme.colors.error : props.theme.colors.neutralText)};
  }

  &:hover {
    border-color: ${props => props.theme.colors.error};
    svg { color: ${props => props.theme.colors.error}; }
  }
`;

// Alerta regulatorio
export const RegulatoryAlert = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin-top: 16px;
  padding: 12px;
  background-color: ${props => rgba(props.theme.colors.warning, 0.1)};
  border: 1px solid ${props => rgba(props.theme.colors.warning, 0.3)};
  border-radius: 12px;

  svg {
    flex-shrink: 0;
    color: ${props => props.theme.colors.warning};
  }

  p {
    margin: 0;
    font-size: 14px;
    color: ${props => props.theme.colors.ink};
    line-height: 1.4;
  }
`;

// Badges de confianca
export const TrustBadgesRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 24px;
`;

export const TrustBadge = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 12px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
  background-color: ${props =>
    props.variant === "warning"
      ? rgba(props.theme.colors.secondary, 0.1)
      : props.theme.colors.neutralBg};
  border: 1px solid ${props =>
    props.variant === "warning"
      ? rgba(props.theme.colors.secondary, 0.3)
      : props.theme.colors.neutralBorder};
  color: ${props =>
    props.variant === "warning"
      ? props.theme.colors.secondary
      : props.theme.colors.ink};

  svg {
    flex-shrink: 0;
    color: ${props =>
      props.variant === "warning"
        ? props.theme.colors.secondary
        : props.theme.colors.primary};
  }
`;

// ===================== Zona 2 — Ficha tecnica =====================
export const TechnicalSheet = styled.section`
  width: 100%;
  max-width: 1440px;
  margin: 32px auto 0 auto;
  display: grid;
  grid-template-columns: 1fr;
  gap: 24px;

  @media ${device.laptop} {
    grid-template-columns: 1fr 1fr;
  }
`;

export const SheetColumn = styled.div`
  min-width: 0;
  background: ${props => props.theme.colors.white};
  border: 1px solid ${props => props.theme.colors.neutralBorder};
  border-radius: 24px;
  box-shadow: var(--cards);
  padding: 24px;

  @media ${device.laptop} {
    padding: 32px;
  }
`;

export const SheetTitle = styled.h2`
  font-family: 'Sora', system-ui, sans-serif;
  font-size: 20px;
  font-weight: 700;
  color: ${props => props.theme.colors.ink};
  margin-bottom: 16px;
`;

export const SheetSubtitle = styled.h3`
  font-family: 'Sora', system-ui, sans-serif;
  font-size: 16px;
  font-weight: 700;
  color: ${props => props.theme.colors.ink};
  margin-bottom: 12px;
`;

export const DescriptionHtml = styled.div`
  color: ${props => props.theme.colors.neutralText};
  font-size: 14px;
  line-height: 1.6;

  h2, h3 {
    color: ${props => props.theme.colors.ink};
    font-weight: 700;
    margin: 16px 0 8px;
  }

  h2 { font-size: 18px; }
  h3 { font-size: 16px; }

  p { margin: 0 0 12px; }

  ul {
    padding-left: 20px;
    margin: 0 0 12px;
    list-style: disc;
  }

  li { margin-bottom: 6px; }

  strong { font-weight: 700; color: ${props => props.theme.colors.ink}; }
`;

export const LegalBoxGray = styled.div`
  margin-top: 20px;
  padding: 8px 12px;
  border: 1px solid ${props => props.theme.colors.neutralBorder};
  background: ${props => props.theme.colors.white};
  border-radius: 12px;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  font-size: 12px;
  color: ${props => props.theme.colors.ink};
  line-height: 1.5;
`;

export const LegalBoxRed = styled.div`
  margin-top: 12px;
  padding: 8px 12px;
  border: 1px solid ${props => props.theme.colors.error};
  background: ${props => props.theme.colors.white};
  border-radius: 12px;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  font-size: 12px;
  color: ${props => props.theme.colors.error};
  line-height: 1.5;
`;

export const AttributesTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;

  tr:nth-child(odd) {
    background-color: ${props => props.theme.colors.neutralBg};
  }

  td {
    padding: 10px 12px;
    vertical-align: top;
  }

  td:first-child {
    width: 50%;
    color: ${props => props.theme.colors.neutralText};
  }

  td:last-child {
    color: ${props => props.theme.colors.ink};
    font-weight: 600;
  }
`;

export const ActivePrinciplesTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
  margin-top: 4px;

  th {
    text-align: left;
    padding: 8px 12px;
    font-size: 13px;
    font-weight: 600;
    color: ${props => props.theme.colors.neutralText};
    border-bottom: 1px solid ${props => props.theme.colors.neutralBorder};
  }

  tbody tr:nth-child(odd) {
    background-color: ${props => props.theme.colors.neutralBg};
  }

  td {
    padding: 10px 12px;
    color: ${props => props.theme.colors.ink};
  }
`;

// ===================== Zona 3 — Relacionados =====================
export const RelatedSection = styled.section`
  width: 100%;
  max-width: 1440px;
  margin: 40px auto 40px auto;

  h2 {
    font-family: 'Sora', system-ui, sans-serif;
    font-size: 20px;
    font-weight: 700;
    color: ${props => props.theme.colors.ink};
    margin-bottom: 16px;
  }
`;

export const RelatedViewport = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const RelatedTrack = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
  overflow-x: auto;
  scroll-behavior: smooth;
  padding: 4px 0 12px;
  flex: 1;

  > * {
    flex: 0 0 auto;
  }

  ::-webkit-scrollbar {
    height: 6px;
  }
  ::-webkit-scrollbar-thumb {
    background: ${props => props.theme.colors.grayLight};
    border-radius: 8px;
  }
`;

export const RelatedArrow = styled.button`
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 1px solid ${props => props.theme.colors.grayLight};
  background: ${props => props.theme.colors.white};
  display: none;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: 0.2s;

  svg {
    width: 20px;
    height: 20px;
    color: ${props => props.theme.colors.primary};
  }

  &:hover {
    border-color: ${props => props.theme.colors.primary};
  }

  @media ${device.laptop} {
    display: flex;
  }
`;
